<template>
  <k-num
    class="k-num--rate"
    :skin="skin"
    :value="value * 100"
    :sign="sign"
    :fixed="2"
    unit="%"
  ></k-num>
</template>

<script>
  import { isString, isNumeric, isUndefined } from '../../utils/base'
  import { fixNumber } from '../../utils/formatter'

  export default {
    name: 'k-rate',
    props: ['value', 'sign', 'unit', 'fixed', 'skin']
  }
</script>
